import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import * as s from './styles';
import Button from '../button/button';

const ChangeSetPointsValueConfirmation = ({
  onCancel = () => {},
  onConfirm,
  loading = false,
  // Props opcionais pra reuso como confirmacao generica (ex.: comandos a
  // equipamento). Defaults preservam o comportamento original (setpoints).
  title = 'Atualizar valor(es) alterado(s)?',
  confirmLabel = 'Atualizar',
  loadingLabel = 'Atualizando...',
  ariaLabel = 'Confirmar mudança de setpoint',
}) => {
  const { colors } = useContext(ThemeContext);
  return (
    <s.ConfirmContainer
      role="dialog"
      aria-live="polite"
      aria-label={ariaLabel}
    >
      <h3>{title}</h3>
      <div>
        <Button
          width="120px"
          height="30px"
          label="Cancelar"
          background="white"
          color={colors.lightblue}
          onClick={onCancel}
          disabled={loading}
        />
        <Button
          disabled={loading}
          width="120px"
          height="30px"
          label={loading ? loadingLabel : confirmLabel}
          background={colors.darkblue}
          color="white"
          animate={false}
          onClick={onConfirm}
        />
      </div>
    </s.ConfirmContainer>
  );
};

export default ChangeSetPointsValueConfirmation;
